import script from "./DFesta.vue?vue&type=script&setup=true&lang=js"
export * from "./DFesta.vue?vue&type=script&setup=true&lang=js"

import "./DFesta.vue?vue&type=style&index=0&id=03de2cb7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03de2cb7"]])

export default __exports__